import { combineEpics, Epic, ofType } from 'redux-observable'
import { catchError, EMPTY, map, mergeMap, of, switchMap } from 'rxjs'
import { getSearchResultsByIssuer } from '../../components/SearchBondsInput/selectors'
import { getHub } from '../../helpers/hub'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { setIssuerFilter } from '../securities/actions'
import {
  getDefaultSecurityFilter,
  getTickerAndMaturity
} from '../securities/helpers'
import { logError } from '../ws/actions'
import {
  GlobalSearchAction,
  globalSearchSuccess,
  SelectFirstIssuerResultAction
} from './actions'
import { searchSecuritiesDefinition } from './definition'
import { createSecuritySearchResultFromResponse } from './helpers'
import { SecuritySearchResult } from './types'

const selectFirstIssuerResultEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType<SelectFirstIssuerResultAction>(
      'searchSecurities.selectFirstIssuerResult'
    ),
    mergeMap((action) => {
      const { gridIndex } = action.payload
      const searchResults = getSearchResultsByIssuer(state$.value)(gridIndex)
      const issuer = searchResults[0]?.issuer
      return issuer ? of(setIssuerFilter(gridIndex, issuer)) : EMPTY
    })
  )

export const querySearch$ = (query: string) => {
  const filters = {
    ...getDefaultSecurityFilter(),
    InWatchlistId: null,
    NotInWatchlistId: null,
    showLive: false,
    ...getTickerAndMaturity(query)
  }
  return getHub()
    .invoke<SecuritySearchResult[]>('SearchSecurities', query, filters)
    .pipe(
      map((securityResponses) =>
        securityResponses.map(createSecuritySearchResultFromResponse)
      )
    )
}

const fetchGlobalSearch: Epic = (action$) =>
  action$.pipe(
    ofType<GlobalSearchAction>('searchSecurities.globalSearch'),
    switchMap((action) => {
      const search$ = querySearch$(action.payload)
      return search$.pipe(
        map((securities) =>
          securities.length
            ? globalSearchSuccess(
                securities.map(createSecuritySearchResultFromResponse)
              )
            : { type: 'ignoreme' }
        ),
        catchError((err) => of(logError(err)))
      )
    })
  )

export default combineEpics(
  createInvokeEpic(
    'searchSecurities.searchSecurities',
    searchSecuritiesDefinition
  ),
  selectFirstIssuerResultEpic,
  fetchGlobalSearch
)
